const ICONS_PATH = '/i/logos/';
export const BaseEngineIcons = {
    yandex: ICONS_PATH + 'ya.webp',
    google: ICONS_PATH + 'google.webp',
    zen: ICONS_PATH + 'dzen.webp',
}
